import React from "react";
import { Backdrop, Box, Typography, LinearProgress } from "@mui/material";

const SubtitleProgressBackdrop = ({ open, completedItems, totalItems, progressPercent }) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        flexDirection: 'column',
        gap: 2,
        backdropFilter: 'blur(8px)',
      }}
      open={open}
    >
      <Box
        sx={{
          width: '80%',
          maxWidth: 400,
          textAlign: 'center',
          p: 3,
          borderRadius: 3,
          bgcolor: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.3)',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'Montserrat',
            fontWeight: 600,
            mb: 2,
            color: '#9834F0',
          }}
        >
          Regenerating Subtitles
        </Typography>
        <LinearProgress
          variant={
            progressPercent !== null && progressPercent < 100
              ? "buffer"
              : progressPercent !== null
              ? "determinate"
              : "indeterminate"
          }
          value={progressPercent ?? 0}
          valueBuffer={
            progressPercent !== null && progressPercent < 100
              ? Math.min(100, progressPercent + 15)
              : progressPercent ?? 0
          }
          sx={{
            height: 10,
            borderRadius: 5,
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#9834F0',
              borderRadius: 5,
            },
            '& .MuiLinearProgress-bar1Buffer': {
              backgroundColor: '#9834F0',
              borderRadius: 5,
            },
            '& .MuiLinearProgress-dashed': {
              backgroundImage: 'none',
              animation: 'none',
            },
          }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1.5 }}>
          <Typography
            variant="body2"
            sx={{
              fontFamily: 'Montserrat',
              fontWeight: 500,
              color: 'rgba(255, 255, 255, 0.7)',
            }}
          >
            {completedItems !== undefined && totalItems !== undefined
              ? `${completedItems} of ${totalItems} processed`
              : "Initializing..."}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontFamily: 'Montserrat',
              fontWeight: 700,
              color: '#9834F0',
            }}
          >
            {progressPercent !== null ? `${progressPercent}%` : "0%"}
          </Typography>
        </Box>
      </Box>
    </Backdrop>
  );
};

export default SubtitleProgressBackdrop;
